<template>
  <div class="valid-code-container">
    <div class="title">
      <span>注册</span>
      <span class="high-light">智库</span>
    </div>
    <div class="sub-title">立即创建帐户并开始使用智库</div>
    <div class="form">
      <el-form ref="formRef" :model="loginForm" :rules="formRules">
        <el-form-item prop="username">
          <div class="inpt-label">用户名</div>
          <el-input v-model="loginForm.username" placeholder="输入用户名" />
        </el-form-item>
        <el-form-item prop="password">
          <div class="inpt-label">密码</div>
          <el-input v-model="loginForm.password" placeholder="输入密码" type="password" />
        </el-form-item>
        <el-form-item prop="repPsd">
          <div class="inpt-label">确认密码</div>
          <el-input v-model="loginForm.repPsd" placeholder="再次输入密码" type="password" />
        </el-form-item>
        <el-form-item prop="phone">
          <div class="inpt-label">手机号</div>
          <el-input v-model="loginForm.phone" placeholder="输入手机号" />
        </el-form-item>
        <el-form-item prop="code">
          <div class="inpt-label">验证码</div>
          <el-input v-model="loginForm.code" placeholder="输入验证码" />
          <div class="tip" @click="validateCodePhone" v-if="!showNum">发送验证码</div>
          <div class="count_down" v-else>{{ countDown }} S</div>
        </el-form-item>
        <el-form-item align="center">
          <div class="login-btn" :loading="false" @click="register">注册</div>
        </el-form-item>
      </el-form>
      <div class="bot-tip flex">
        <el-checkbox-group v-model="loginForm.agreenChecked">
          <el-checkbox label="1" name="type">我已阅读并同意<span class="agreement" @click="goAgreenMentClick">《平台服务协议》</span></el-checkbox>
        </el-checkbox-group>
        <div class="right-tip">
          <span>已有账号？</span>
          <span class="login-tip" @click="changeCurrentCom('ValiCodeCom')">登录</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { register, validateCodePhoneApi } from '@/apis/index.js'
let timer = null
export default {
  name: 'WorkspaceJsonAccountLogin',
  data() {
    let validateConfirmPsd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.loginForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        productCode: 'TDS',
        username: '',
        password: '',
        repPsd: '',
        phone: '',
        cid: '',
        code: '',
        weixininfo: '',
        agreenChecked: [],
      },
      formRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: ['blur'] },
          {
            pattern: /^(?!^\\d+$)[0-9a-zA-Z_]{8,15}$/,
            message: '用户名仅支持英文、数字、下划线，且不能为纯数字，长度8~15',
          },
          {
            validator: (rule, value, callBack) => this.$checkTypeValidator(1, true, value, callBack),
            trigger: ['blur'],
          },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: ['blur'] },
          {
            pattern:
              /^(?!\d+$)(?![A-Za-z]+$)(?![`~!@#\$%\^&\*\(\)\-_=\+\\\|\[\{\]\};:',<\.>/\?]+$)[A-Za-z\d`~!@#\$%\^&\*\(\)\-_=\+\\\|\[\{\]\};:',<\.>/\?]{8,15}$/,
            message: '登录密码仅支持英文、数字、标点符号至少包含2种，长度8~15',
          },
        ],
        repPsd: [{ required: true, validator: validateConfirmPsd, trigger: ['blur'] }],
        phone: [
          { required: true, message: '不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '电话号码格式错误',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callBack) => this.$checkTypeValidator(2, true, value, callBack),
            trigger: ['blur'],
          },
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: ['blur'],
          },
        ],
        agreenChecked: [{ required: true, message: '请确认您已阅读并同意《平台服务协议》', trigger: ['change'] }],
      },
      showNum: false,
      countDown: 60,
    }
  },
  async mounted() {},
  beforeDestroy(){
    timer = null
    clearInterval(timer)
  },
  methods: {
    changeLoginClick() {
      this.$emit('changeLoginClick', 'login')
    },
    register() {
      this.$refs.formRef.validate(async (v) => {
        if (!v) return
        let res = await register(this.loginForm)
        if (res.success == true) {
          this.$emit('loginSuccess', res)
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    validateCodePhone() {
      this.$refs.formRef.validateField(['phone'], async (v) => {
        if (!v) {
          this.$message.success('验证码已发送，请注意查收')
          // 没有错误信息----验证通过
          // 获取短信验证码
          let res = await validateCodePhoneApi(this.loginForm.phone)
          if (res.success) {
            const { uuid } = res.data
            this.loginForm.cid = uuid
            this.showNum = true
            this.countDown = 60
            clearInterval(timer)
            timer = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown -= 1
              } else {
                this.showNum = false
              }
            }, 1000)
          }else{
            this.$message.error(res.msg)
          }
        }
      })
    },
    goAgreenMentClick() {
      let path = this.$router.resolve('/user_agreement')
      window.open(path.href, '_blank')
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
  },
}
</script>
<style lang="less" scoped>
.valid-code-container {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px 10px 10px 10px;
  .title {
    font-weight: bold;
    font-size: 32px;
    color: #03133d;
    line-height: 34px;
    .high-light {
      margin-left: 10px;
      color: #0677e7;
    }
  }
  .sub-title {
    margin-top: 12px;
    font-size: 18px;
    color: #68718b;
    line-height: 24px;
  }
  .form {
    margin-top: 32px;
    /deep/.el-input__inner {
      width: 380px;
      height: 44px;
      line-height: 44px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #cdd0d8;
    }
    .base64img {
      margin-left: 12px;
      width: 100px;
      height: 38px;
    }
    .inpt-label {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #03133d;
      line-height: 22px;
    }
    .input {
      /deep/.el-input__inner {
        width: 268px;
      }
    }
    .tip,
    .count_down {
      position: absolute;
      right: 0;
      bottom: -22px;
      font-size: 14px;
      color: #006fba;
      line-height: 20px;
      cursor: pointer;
    }
    .count_down {
      cursor: default;
      color: #8e8e8e;
    }
    .login-btn {
      margin-top: 24px;
      width: 380px;
      height: 54px;
      background: linear-gradient(160deg, #0c87f0 0%, #036fe2 100%);
      border-radius: 10px 10px 10px 10px;
      line-height: 54px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
    .regist-tip {
      text-align: center;
      font-size: 14px;
      color: #68718b;
    }
    .regist-btn {
      color: #006fba;
      font-weight: bold;
    }
    .bot-tip {
      margin-top: 24px;
      .agreement{
        text-decoration: underline;
        
      }
    }
    .right-tip {
      margin-left: auto;
      font-size: 14px;
      color: #68718b;
    }
    .login-tip {
      cursor: pointer;
      color: #006fba;
      font-weight: bold;
    }
  }
}
</style>
